import React from "react";
import { Section, SectionHeading } from "./Section";
import { VolumeCard } from "./VolumeCard";
import { volumes } from "../data/volumes";
export function VolumesSection() {
  return <Section tone="cream" labelledBy="volumes-title" cta="I want all 6 premium volumes" data-id="element-352" data-mp="co92z07l50hl">
      <SectionHeading id="volumes-title" eyebrow="What you'll find inside Facelift Blueprint™" title={<>
            6 Premium Volumes. <em className="text-gold-dark" data-id="element-354" data-mp="3g5hk1huhnwb9">One Complete Educational System.</em>
          </>} data-id="element-353" data-mp="7pejrx5ph9wy" />
      <div className="mt-10 grid gap-6 lg:grid-cols-2 lg:items-start" data-id="element-355" data-mp="3c1jjd2pimdg3">
        {volumes.map(v => <VolumeCard key={v.numeral} volume={v} data-id="element-356" data-mp="3px43g1gzd1p3" />)}
      </div>
    </Section>;
}